import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Collapse, TableCell, TableRow } from '@mui/material';

import OnFileDownloadIcon from '../../../../icons/OnFileDownloadIcon';
import { reverseFormatDate } from '../../../../utils/dateFunctions';
import { hasRole } from '../../../../utils/userRoles';

import RejectionDetails from './RejectionDetails';

import classes from '../../../../commonStyles/tables.module.css';

const PoolsRow = ({ row, roles, acceptedRoles, openId, toggleDropdown, onDownload }) => {
    // LOCAL STATE
    const [open, setOpen] = useState(null);

    // USE EFFECTS
    useEffect(() => {
        if (openId !== row.id) setOpen(null);
    }, [openId]);

    const onToggleDropdown = () => {
        toggleDropdown(row.id);
        setOpen(open === row.id ? null : row.id);
    };

    // RENDER
    return (
        <>
            <TableRow
                key={row.id}
                hover
                className={classes.basicRowStripes}
                onClick={onToggleDropdown}>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.ownerName}</TableCell>
                <TableCell>{row.sectorName}</TableCell>
                <TableCell disabled={!hasRole(acceptedRoles, roles)}>{row.filename}</TableCell>
                <TableCell align="center">
                    <OnFileDownloadIcon
                        active={hasRole(acceptedRoles, roles) && row?.filename !== ''}
                        onDownload={() => onDownload(row)}
                    />
                </TableCell>
                <TableCell>{reverseFormatDate(row.startDate)}</TableCell>
                <TableCell>{row.statusName}</TableCell>
            </TableRow>
            {!row.statusName || row.statusName.toLowerCase() !== 'rejected' ? (
                ''
            ) : (
                <TableRow>
                    <TableCell
                        style={{
                            paddingBottom: 0,
                            paddingTop: 0,
                            paddingLeft: 0,
                            paddingRight: 0,
                            borderTop: 'none',
                            borderBottom: 'none'
                        }}
                        colSpan={7}>
                        <Collapse in={open === row.id} timeout="auto" unmountOnExit>
                            <Box>
                                <RejectionDetails row={row} onClose={() => setOpen(null)} />
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </>
    );
};

PoolsRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    openId: PropTypes.string,
    toggleDropdown: PropTypes.func,
    onDownload: PropTypes.func
};

export default PoolsRow;
